module.exports = __webpack_public_path__ + "img/purplesplendor.e5798df9.png";